import { cn } from '@/lib/utils'
import { Button } from '../Button/Button'
import GoldBorderGradient from '../ui/gold-border-gradient'
type FormButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>

export function FormButton({ className, children, ...props }: FormButtonProps) {
  return (
    <Button
      variant="dark"
      className={cn('relative flex items-center justify-center font-bold', className)}
      {...props}
    >
      <GoldBorderGradient className="rounded-full" />
      {children}
    </Button>
  )
}
